import { connect } from '~/store';
import { Election } from '~/helpers/types/Election';

/** Store helper; provides the election details. */
export default (component: any): (props: any) => any => (
  connect(({ election }: { election: Election }) => ({ election }))(component)
);
